// extracted by mini-css-extract-plugin
module.exports = {"loadMorePosts":"LoadMorePosts_loadMorePosts__5wG8Z","button":"LoadMorePosts_button__WafK3"};